const TYPES = {
    SET: 'contacts.set',
    UPDATE_SUBSCRIPTION: 'contacts.updateSubscription',
    CLEAR_ALL: 'contacts.clearAll',
};

export default TYPES;
